import { Injectable, inject } from '@angular/core';

import { CurrenciesState } from './currencies.state';

@Injectable({
  providedIn: 'root'
})
export class Converter {
  private readonly currenciesState = inject(CurrenciesState);

  convert(
    amount: number,
    from: string|null = null,
    to: string|null = null,
    maxFractionDigits: number|null = 2
  ): string|null {
    from = from || this.currenciesState.base();
    to = to || this.currenciesState.userCurrency();

    if(Number.isNaN(amount)) {
      return null;
    }

    if(0 === amount || from === to) {
      return String(amount);
    }

    amount *= this.getRate(from, to);

    if(null === maxFractionDigits) {
      return String(amount);
    }

    return amount.toFixed(maxFractionDigits);
  }

  getRate(from: string, to: string): number {
    const base = this.currenciesState.base();
    const rates = this.currenciesState.rates();

    from = from.toUpperCase();
    to = to.toUpperCase();

    // If `from` currency === fx.base, return the basic exchange rate for the `to` currency
    if(from === base) {
      return rates[to];
    }

    // If `to` currency === fx.base, return the basic inverse rate of the `from` currency
    if(to === base) {
      return 1 / rates[from];
    }

    // Otherwise, return the `to` rate multipled by the inverse of the `from` rate to get the
    // relative exchange rate between the two currencies
    return rates[to] * (1 / rates[from]);
  }
}
